<template>
  <div class="">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form :model="ruleForm" ref="formRef" label-width="125px" class="demo-ruleForm">
        <el-form-item label="操作时间：" prop="money">
          <span>{{ row.createTime }}</span>
        </el-form-item>
        <el-form-item label="操作人：" prop="money">
          <span>{{ row.createUserName ? row.createUserName : row.createBy }}</span>
        </el-form-item>
        <el-form-item label="变动金额（元）：" prop="money">
          <span v-if="row.changeAmountType != null">
            <span v-if="row.changeAmountType == 0" class="add"> + <span> {{ row.amountChange ?
              parseFloat(row.amountChange).toFixed(2) : '0.00' }}</span></span>
            <span v-if="row.changeAmountType == 1" class="reduce"> - <span>{{ row.amountChange ?
              parseFloat(row.amountChange).toFixed(2) : '0.00' }}</span></span>
          </span>
          <span v-else>
            <span v-if="row.type == 1" class="add"> + <span> {{ row.amount ?
              parseFloat(row.amount).toFixed(2) : '0.00' }}</span></span>
            <span v-if="row.type == 2" class="reduce"> - <span>{{ row.amount ?
              parseFloat(row.amount).toFixed(2) : '0.00' }}</span></span>
          </span>
        </el-form-item>
        <el-form-item label="操作原因：" prop="money">
          <span>{{ row.remark ? row.remark : row.remarks }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
<script>

export default {
  props: {
  },
  data () {
    return {
      options: [
        {
          value: '1',
          label: '保证金充值'
        },
        {
          value: '2',
          label: '订单资金冻结'
        },
        {
          value: '3',
          label: '服务费扣除'
        }, {
          value: '4',
          label: '售后资金扣减'
        }, {
          value: '5',
          label: '订单资金解冻'
        },
        {
          value: '6',
          label: '超时赔付'
        },
        {
          value: '7',
          label: '服务费冻结'
        },
        {
          value: '8',
          label: '服务费解冻'
        },
        {
          value: '9',
          label: '订单超时赔付金额冻结'
        },
        {
          value: '10',
          label: '订单超时赔付金额解冻'
        },
        {
          value: '11',
          label: '订单超时赔付金额扣减'
        },
        {
          value: '12',
          label: '平台增额'
        },
        {
          value: '13',
          label: '平台扣减'
        },
      ],
      row: {},
      title: '提示',
      type: '1',
      dialogVisible: false,
      ruleForm: {
        money: '',
        reason: ''
      },
    }
  },
  components: {},
  created () {

  },
  mounted () {

  },
  watch: {},
  methods: {
    open (row, title) {
      this.row = row;
      this.title = title;
      this.dialogVisible = true;
    },
    handleClose () {
      this.dialogVisible = false;
    },
    filterReasonType () {
      let reason = this.row.reason;
      let reasonType = this.options.filter(item => item.value == reason);
      return reasonType[0].label;
    }
  }
}

</script>
<style lang="scss" scoped>
.reduce {
  color: green;
}

.add {
  color: #F5222D;
}
</style>
